angular.module('impactx.monitordashboard').controller('BusinessOrderItemListCtrl', BusinessOrderItemListCtrl);

function BusinessOrderItemListCtrl() {
    this.meta = {
        rowTemplate: 'modules/monitor/templates/businessorderitem.row.html',
        isSelectAble: false,
        endpoint: '/business/order/items',
        ctrl: this,
        id: "businessorderitemlist",
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    };
}